import type { NetworkPayload } from "../../../composites";

export const API = {
  parseCSV: (
    payload: API.WireImport.ParseCSV.Request,
  ): NetworkPayload<API.WireImport.ParseCSV.Request> => {
    return {
      url: "wire_import/csv/parse/",
      options: {
        method: "POST",
        payload,
      },
    };
  },

  submit: (
    payload: API.WireImport.Submit.Request,
  ): NetworkPayload<API.WireImport.Submit.Request> => {
    return {
      url: "wire_import/csv/submit/",
      options: {
        method: "POST",
        payload,
      },
    };
  },

  fetchMappings: (): NetworkPayload => {
    return {
      url: "wire_import/csv/mappings/",
      options: {
        method: "GET",
      },
    };
  },

  createMapping: (
    payload: API.WireImport.CSVFieldMappingRequest,
  ): NetworkPayload<API.WireImport.CSVFieldMappingRequest> => {
    return {
      url: "wire_import/csv/mappings/",
      options: {
        method: "POST",
        payload,
      },
    };
  },

  updateMapping: (
    uuid: string,
    payload: API.WireImport.CSVFieldMappingRequest,
  ): NetworkPayload<API.WireImport.CSVFieldMappingRequest> => {
    return {
      url: `wire_import/csv/mappings/${uuid}/`,
      options: {
        method: "PUT",
        payload,
      },
    };
  },

  deleteMapping: (uuid: string): NetworkPayload => {
    return {
      url: `wire_import/csv/mappings/${uuid}/`,
      options: {
        method: "DELETE",
        isJsonResponse: false,
      },
    };
  },

  fetchBatch: (uuid: string): NetworkPayload => {
    return {
      url: `wire_import/batches/${uuid}/`,
      options: {
        method: "GET",
      },
    };
  },
};
